import * as React from 'react';
import { PaymentHistoryItem, PaymentHistoryItemProps } from "./PaymentHistoryItem";

export interface PaymentHistoryListProps {
    paymentHistory: PaymentHistoryItemProps[];
    emitHandleScheduleSpecialDebit;
    emitHandleRetryPayment;
}

export class PaymentHistoryList extends React.Component<PaymentHistoryListProps> {
    constructor(props: PaymentHistoryListProps) {
        super(props);
        
        this.handleScheduleSpecialDebit = this.handleScheduleSpecialDebit.bind(this);
        this.handleRetryPayment = this.handleRetryPayment.bind(this);
    }
    
    async handleScheduleSpecialDebit(e: any) {
        this.props.emitHandleScheduleSpecialDebit(e);
    }

    async handleRetryPayment(e: any) {
        this.props.emitHandleRetryPayment(e);
    }
    
    public render() {
        return (
            <>
            { this.props.paymentHistory?.length > 0 ? this.props.paymentHistory.map(({amount, date, status, id, isSpecialDebit}, index) => 
                <React.Fragment key={index}>
                    <PaymentHistoryItem emitHandleRetryPayment={this.handleRetryPayment} isSpecialDebit={isSpecialDebit} emitHandleScheduleSpecialDebit={this.handleScheduleSpecialDebit} id={id} key={index} amount={amount} date={date} status={status} />
                { index < this.props.paymentHistory.length - 1 && <hr className="m-2" /> }
                </React.Fragment>
            ): 
            <>
                <p className="font-weight-bold text-right">
                    <span>No collections yet!</span>
                </p>
            </>
            
            }
            </>
        )
    }
}